// src/pages/Archive/index.jsx
import React, { useState, useEffect } from 'react';
import { 
  Layout, 
  Card, 
  Timeline, 
  Typography, 
  Tag, 
  Empty,
  Skeleton,
  Button,
  Space
} from 'antd';
import { 
  CalendarOutlined, 
  EyeOutlined, 
  HeartOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { mockPosts } from '../../api/mockData';

const { Content } = Layout;
const { Title, Text } = Typography;

const Archive = ({ posts, loading, error, loggedInUser, onLogout }) => {
  const [archivedPosts, setArchivedPosts] = useState([]);

  useEffect(() => {
    // 按年月分组文章
    const groupedPosts = {};
    
    [...mockPosts].sort((a, b) => new Date(b.date) - new Date(a.date)).forEach(post => {
      const date = new Date(post.date);
      const yearMonth = `${date.getFullYear()}年${(date.getMonth() + 1).toString().padStart(2, '0')}月`;
      
      if (!groupedPosts[yearMonth]) {
        groupedPosts[yearMonth] = [];
      }
      
      groupedPosts[yearMonth].push(post);
    });
    
    setArchivedPosts(groupedPosts);
  }, []);

  if (loading) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <AppHeader />
        <Content style={{ padding: '20px 50px', marginTop: '64px' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </div>
        </Content>
        <AppFooter />
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <AppHeader />
        <Content style={{ padding: '20px 50px', marginTop: '64px' }}>
          <Card>
            <Empty description={error} />
          </Card>
        </Content>
        <AppFooter />
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader />
      
      <Content style={{ padding: '20px 50px', marginTop: '64px' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Button 
            type="link" 
            icon={<ArrowLeftOutlined />} 
            onClick={() => window.history.back()}
            style={{ marginBottom: '16px' }}
          >
            返回
          </Button>
          
          <Title level={2}>文章归档</Title>
          
          {Object.keys(archivedPosts).length > 0 ? (
            <Timeline mode="left">
              {Object.entries(archivedPosts).map(([month, postsInMonth]) => (
                <Timeline.Item key={month} label={month} style={{ padding: '10px 0' }}>
                  <div style={{ marginBottom: '10px' }}>
                    <Text strong>{month}</Text> (<Text type="secondary">{postsInMonth.length}篇文章</Text>)
                  </div>
                  
                  {postsInMonth.map((post) => (
                    <Card 
                      key={post.id}
                      style={{ marginBottom: '10px', cursor: 'pointer' }}
                      hoverable
                      onClick={() => window.location.hash = `#/post/${post.id}`}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <Title level={4} style={{ margin: 0 }}>
                            {post.title}
                          </Title>
                          <Text type="secondary" style={{ fontSize: '12px' }}>
                            {post.date}
                          </Text>
                        </div>
                        
                        <Space size="small">
                          <Tag color="blue">{post.category}</Tag>
                          <Space size="small" style={{ color: '#8c8c8c' }}>
                            <EyeOutlined />
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                              {post.views}
                            </Text>
                            <HeartOutlined />
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                              {post.likes}
                            </Text>
                          </Space>
                        </Space>
                      </div>
                    </Card>
                  ))}
                </Timeline.Item>
              ))}
            </Timeline>
          ) : (
            <Card>
              <Empty description="暂无归档文章" />
            </Card>
          )}
        </div>
      </Content>
      
      <AppFooter />
    </Layout>
  );
};

export default Archive;